import axios from 'axios'
import qs from "qs";

var keyArr = []

export default {
  round(number, count = 2) {
    if (String(number) == 'NaN' || !number) {
      return 0
    } else {
      return Math.round(number * Math.pow(10, count)) / Math.pow(10, count)
    }
  }
  ,
  getDate() {
    let dt = new Date();
    let yy = dt.getFullYear();
    let mm = dt.getMonth() + 1;
    if (mm < 10)
      mm = '0' + mm;
    let dd = dt.getDate();
    if (dd < 10)
      dd = '0' + dd;
    return yy + "-" + mm + "-" + dd;
  }
  ,
  getDate2(dt) {
    // let dt = new Date();
    let yy = dt.getFullYear();
    let mm = dt.getMonth() + 1;
    if (mm < 10)
      mm = '0' + mm;
    let dd = dt.getDate();
    if (dd < 10)
      dd = '0' + dd;
    return yy + "-" + mm + "-" + dd;
  }
  ,
  getMonthDate() {
    let dt = new Date();
    let yy = dt.getFullYear();
    let mm = dt.getMonth() + 1;
    if (mm < 10)
      mm = '0' + mm;
    return yy + "-" + mm;
  }
  ,
  getDateTime(d) {
    let dt = d || new Date();
    let yy = dt.getFullYear();
    let mm = dt.getMonth() + 1;
    if (mm < 10)
      mm = '0' + mm;
    let dd = dt.getDate();
    if (dd < 10)
      dd = '0' + dd;
    let hh = dt.getHours();
    if (hh < 10)
      hh = '0' + hh;
    let ff = dt.getMinutes();
    if (ff < 10)
      ff = '0' + ff;
    return yy + "-" + mm + "-" + dd + " " + hh + ":" + ff;
  }
  ,
  getTime() {
    let dt = new Date();
    let hh = dt.getHours();
    if (hh < 10)
      hh = '0' + hh;
    let mm = dt.getMinutes();
    if (mm < 10)
      mm = '0' + mm;
    return hh + ":" + mm;
  }
  ,
  async getClass() {
    var dataList = [];
    var classData = localStorage.getItem("classData") || "";
    if (classData) {
      dataList = JSON.parse(classData);
    } else {
      await axios
        .post("api/YYT3PC/Home/GetTeacherClass")
        .then((res) => {
          let data = res.data;
          console.log(res)
          if (data.resultType == 0) {
            // data.appendData.unshift({ kinderGartenClassId: 0, className: "全部班级" });
            localStorage.setItem(
              "classData",
              JSON.stringify(data.appendData)
            );
            dataList = data.appendData;
          } else {
            this.$alert(data.message);
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    }
    return dataList;
  }
  ,

  async getPlace() {
    var dataList = [];
    var placeData = localStorage.getItem("placeData") || "";
    if (placeData) {
      dataList = JSON.parse(placeData);
    } else {
      await axios
        .post("api/YYT3PC/Home/GetxdPlaces")
        .then((res) => {
          let data = res.data;
          console.log(res)
          if (data.resultType == 0) {
            localStorage.setItem(
              "placeData",
              JSON.stringify(data.appendData)
            );
            dataList = data.appendData;
          } else {
            this.$alert(data.message);
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    }
    return dataList;
  }
  ,

  async getSemester() {
    var dataList = [];
    var semesterData = localStorage.getItem("semesterData") || "";
    if (semesterData) {
      dataList = JSON.parse(semesterData);
    } else {
      await axios
        .post("api/yyt3pc/home/GetSchoolTerm")
        .then((res) => {
          let data = res.data;
          if (data.resultType == 0) {
            localStorage.setItem("semesterData", JSON.stringify(data.appendData));
            dataList = data.appendData;
          } else {
            this.$alert(data.message);
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    }
    return dataList;
  }
  ,
  async getAliyun() {
    var aliyun = {};
    await axios
      .get("api/AliOss/Get")
      .then((res) => {
        let data = res.data;
        if (data.resultType == 0) {
          aliyun = data.appendData;
        } else {
          this.$alert(data.message);
        }
      })
      .catch((err) => {
        this.$alert(err);
      });
    return aliyun
  }
  ,
  resetCriwd() {
    localStorage.removeItem("crowds");
    this.axios
      .post("api/yyt3pc/meal/GetCrowds")
      .then((res) => {
        let data = res.data;
        if (data.resultType == 0) {
          localStorage.setItem("crowds", JSON.stringify(data.appendData));
          dataList = data.appendData;
        } else {
          this.$alert(data.message);
        }
      })
      .catch((err) => {
        this.$alert(err);
      });
  }
  ,
  async getCrowd() {
    var dataList = [];
    var crowds = localStorage.getItem("crowds") || "";
    if (crowds) {
      dataList = JSON.parse(crowds);
    } else {
      await axios
        .post("api/yyt3pc/meal/GetCrowds")
        .then((res) => {
          let data = res.data;
          if (data.resultType == 0) {
            localStorage.setItem("crowds", JSON.stringify(data.appendData));
            dataList = data.appendData;
          } else {
            this.$alert(data.message);
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    }
    return dataList;
  }
  ,
  getGuid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  }
  ,
  getFileName(file) {
    var fileName = "Images";
    if (file.type.indexOf("image") != -1)
      fileName = "Images";
    else if (file.type.indexOf("audio") != -1)
      fileName = "Audios";
    else if (file.type.indexOf("video") != -1)
      fileName = "Videos";
    let index = file.name.lastIndexOf(".");
    let ext = file.name.substr(index + 1).toLowerCase();
    var dt = this.getDate().replace('-', '/').replace('-', '/');
    return fileName + "/" + dt + "/" + "oss_" + this.getGuid() + "." + ext;
  }
  ,
  downLoad(url) {
    var downloadElement = document.createElement('a');
    // downloadElement.download = url.slice(url.lastIndexOf('/') + 1);
    downloadElement.style.display = "none";
    downloadElement.href = url;
    downloadElement.target = '_blank'
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
  }
  ,
  downLoadBase64(filename, content) {
    let aLink = document.createElement('a');
    let blob = this.base64ToBlob(content); //new Blob([content]);

    let evt = document.createEvent("HTMLEvents");
    evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = filename;
    aLink.href = URL.createObjectURL(blob);
    aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
  }
  ,
  base64ToBlob(code) {
    let contentType = code.split(':')[1];
    let raw = window.atob(code);
    let rawLength = raw.length;
    let uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {type: contentType});
  }
  ,
  isNumber(val) {
    // return typeof val === 'number' && !isNaN(val);
    var re = /^[0-9]+.?[0-9]*/;
    return re.test(val)
  }
  ,
  isExcel(file) {
    let isExcel =
      file.type === "application/vnd.ms-excel" ||
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    return isExcel;
  }
  ,
  getStartDayByWeek(date) {
    date = date || new Date()
    const dayOfWeek = date.getDay();
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // 如果是周日(0)，则回到上周一；否则，往前推到周一
    const startOfWeek = new Date(date);
    startOfWeek.setDate(date.getDate() + diff);
    return startOfWeek;
  },
//获取每周第一天
  getFirstDayByWeek(d) {
    var date = d || new Date();
    var time = date.getTime();
    var day = date.getDay() || 7;
    var oneDay = 24 * 60 * 60 * 1000;
    var mondayTime = time - (day - 1) * oneDay;
    var mondayDate = new Date(mondayTime);
    return this.getDate2(mondayDate);
  }
  ,
// 根据日期判断是月的第几周
  getWeekInMonth(date, firstDayOfWeek = 1) {
    // 创建副本避免修改原始日期对象
    let d = new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth(); // 注意：月份从0开始
    // 获取当月第一天和最后一天
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    // 根据firstDayOfWeek调整差值（1表示周一，0表示周日）
    const dayOfWeekFirstDay = (7 + firstDayOfMonth.getDay() - firstDayOfWeek) % 7;

    // 计算从当月第一天到今天的完整天数
    const diffDays = Math.floor((d - firstDayOfMonth) / (1000 * 60 * 60 * 24));

    // 初始计算是第几周
    let weekOfMonth = Math.ceil((diffDays + dayOfWeekFirstDay) / 7);

    // 如果第一周包含了上个月的天数，则不计入第一周
    if (dayOfWeekFirstDay > 0 && weekOfMonth >= 1) {
      weekOfMonth += 1;
    }

    // 检查是否为最后一周且跨越了月份或年份
    if (d.getDate() >= lastDayOfMonth.getDate() - 6) { // 最后七天内
      // 创建该月最后一天的那一周的第一个日期
      const startOfWeekLastMonth = new Date(lastDayOfMonth.setDate(lastDayOfMonth.getDate() - ((lastDayOfMonth.getDay() + 7 - firstDayOfWeek) % 7)));

      // 如果当前日期在那一周内，并且这一周横跨到了下一个月
      if (startOfWeekLastMonth <= d && d <= lastDayOfMonth) {
        // 检查是否跨越了月份或年份
        const nextMonthStart = new Date(year, month + 1, 1);
        if (nextMonthStart.getMonth() !== month || nextMonthStart.getFullYear() !== year) {
          // 如果跨越了月份或年份，返回新月份的第一周
          return `${nextMonthStart.getFullYear()}-${String(nextMonthStart.getMonth() + 1).padStart(2, '0')} 第1周`;
        }
      }
    }

    // 确保至少有一个有效周数
    weekOfMonth = weekOfMonth > 0 ? weekOfMonth : "不属于本月";

    // 返回格式化的字符串
    return `${year}-${String(month + 1).padStart(2, '0')} 第${weekOfMonth}周`;
  }
  ,
  getToken() {
    return true;
  }
  ,
  async getSymptom() {
    //var symptoms = ["体温高", "有感冒", "头痛", "红斑肿", "肋腺肿大", "恶心", "呕吐", "咳嗽", "肠胃不适", "皮疹", "腹泻", "黄疸", "牙疼", "外伤", "鼻塞", "流涕", "咽喉吞咽痛", "舌头发红", "手足出现红疹", "口腔出现疱疹", "眼睛发红", "其他"];
    var symptoms = [];
    var symptomData = localStorage.getItem("symptomData") || "";
    if (symptomData) {
      symptoms = JSON.parse(symptomData);
    } else {
      await axios
        .post("api/YYT3PC/Attendance/GetSymptoms")
        .then((res) => {
          let data = res.data;
          if (data.resultType == 0) {
            localStorage.setItem("symptomData", JSON.stringify(data.appendData));
            symptoms = data.appendData;
          } else {
            this.$alert(data.message);
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    }
    return symptoms;
  }
  ,
  getSearchResult(data) {
    if (data == null || data.length == 0)
      return "未查询到数据"
    else
      return ""
  }
  ,
  counter(key) {
    if (key) {
      var obj = {
        key: key,
        count: 1
      }

      var i = ''
      var arr = keyArr.find((item, index) => {
        i = index
        return item.key == key
      })
      if (arr) {
        keyArr[i].count += 1
      } else {
        keyArr.push(obj)
      }
    }
    // console.log('keyArr', keyArr)
  }
  ,
  task() {
    if (keyArr.length > 0) {
      console.log("心跳包：执行统计提交");
      console.log("data", keyArr);
      loop()
    }
  }
  ,
  copy(value) {
    const element = document.createElement('textarea')
    document.body.appendChild(element)
    element.value = value
    element.select()

    document.execCommand('copy')
    document.body.removeChild(element)

  }
  ,
  getEndDate(startDate) {
    var sdt = new Date(startDate);
    var timeSpans = sdt.valueOf() + 1000 * 60 * 60 * 24 * 6;
    var edt = new Date(timeSpans);
    var month = edt.getMonth() + 1;
    var day = edt.getDate();
    return (
      (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day)
    );
  }
  ,
  getWeekDate(startDate, wi) {
    var sdt = new Date(startDate);
    var timeSpans = sdt.valueOf() + 1000 * 60 * 60 * 24 * (wi - 1);
    var edt = new Date(timeSpans);
    var year = edt.getFullYear();
    var month = edt.getMonth() + 1;
    var day = edt.getDate();
    return (
      year + '-' + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day)
    );
  }
  ,
  DateFormat(date, fmt) {
    var o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }
  ,
  getMonday(type, dates) {
    //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，dates为数字类型，不传或0代表本周，-1代表上周，1代表下周
    var now = new Date();
    var nowTime = now.getTime();
    var day = now.getDay();
    var longTime = 24 * 60 * 60 * 1000;
    var n = longTime * 7 * (dates || 0);
    if (type == "s") {
      var dd = nowTime - (day - 1) * longTime + n;
    }
    ;
    if (type == "e") {
      var dd = nowTime + (7 - day) * longTime + n;
    }
    ;
    dd = new Date(dd);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1;
    var d = dd.getDate();
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    var day = y + "-" + m + "-" + d;
    return day;
  },
  saveBase64AsFile(base64Data, fileName) {
    // 去除 Base64 数据的前缀
    const base64Content = base64Data.replace(/^data:.*;base64,/, "");
    // 将 Base64 数据转换为 Uint8Array
    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    // 创建 Blob 对象
    const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    // 创建临时的 <a> 标签
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // 模拟点击 <a> 标签触发下载
    link.click();
    // 释放 Blob 对象的 URL
    URL.revokeObjectURL(link.href);
  },
  // 使用Audio API获取音频文件时长
  getAudioDuration(file) {
    return new Promise((resolve, reject) => {
      const audio = new Audio();
      const objectUrl = URL.createObjectURL(file);

      audio.onloadedmetadata = () => {
        URL.revokeObjectURL(objectUrl); // 清理内存
        resolve(audio.duration);
      };

      audio.onerror = (error) => {
        URL.revokeObjectURL(objectUrl); // 清理内存
        reject(error);
      };

      audio.src = objectUrl;
    });
  },
  // 将秒数转换为 MM:SS 格式
  formatDuration(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  },
}

async function loop() {
  var tk = localStorage.getItem("dataToken");
  var schoolGuid = localStorage.getItem("schoolGuid");
  if (tk && schoolGuid) {
    for (let i = 0; i < keyArr.length; i++) {
      if (keyArr[i].key) {
        await send(keyArr[i], tk, schoolGuid)
        keyArr.splice(i, 1)
        i--
      }
    }
  } else {
    keyArr = [];
  }
}

function send(item, tk, schoolGuid) {
  resovle()
  // return new Promise((resovle) => {
  //   axios
  //     .post(
  //       '/dataapi/REC/DATA/SAVE?apk=DZYYT&token=' + tk,
  //       qs.stringify({
  //         SCH_GUID: schoolGuid,
  //         FUNC_CAT: 1,
  //         FUNC_KEY: item.key,
  //         CNT: item.count
  //       }))
  //     .then((res) => {
  //       resovle()
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // })
}






// WEBPACK FOOTER //
// ./src/assets/js/common.js